<template>
  <v-item :title="title">
    <el-radio-group v-model="current">
      <el-radio class="c-version-item" v-for="r in data" :key="r.value" :label="r.value">{{ r.label }}</el-radio>
    </el-radio-group>
  </v-item>
</template>
<script>
import VItem from './v-item'
export default {
  name: 'Version',
  components: { VItem },
  props: {
    value: {
      type: [String, Number],
      default: 'NONE'
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    title: {
      type: String,
      default: '版本',
      required: true
    },
    android: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    current: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-select-item {
  width: 400px;
  .c-version-item {
    display: block;
    height: 34px;
    line-height: 34px;
    margin-left: 12px;
  }
}
</style>
